
const network = require( "./network/network_api" );

export default function(
    parent,
    $state,
)
{
    const space = parent.child( "balance" );
    
    const $balance = parent.s( "balance" );
    parent.s( "net" )
        .map( net => net.balance )
        .to( $balance );
    //TODO: there is a potential time gap when balance polling request may succeed before spin initiation will and so will overwrite client-side credits prediction:
    parent.s( "balance_poll" ).to( $balance );
    
    const $clientCredits = $balance.map( balance => balance.gameable );
    //cannot merge directly with server due to Rx bug(not defined issue):
    $clientCredits.subscribe( space.s( "credits" ) );
    space.s( "creditsChange" )
        .withLatestFrom( $clientCredits, ( change, credits ) => credits + change )
        .subscribe( space.s( "credits" ) );
    
    $balance
        .map( balance => balance.gameable_money )
        .name( space, "money" )
    
    //when any previous win flow initiation completes or interrupts:
    const winFlowDone = () => space.s( "winFlowComplete" ).next();
    var tween = undefined;
    const $winFlow = space.s( "winFlow", 0 );
    const $winTarget = space.s( "winTarget", 0 );
    const interrupt = winTarget => {
        if ( tween )
        {
            tween.stop();
            tween = undefined;
        }
        $winFlow.next( winTarget );
    };
    space.s( "winFlowUp" )
        .desc( "request to flow up another portion of winnings, any previous win flow process will terminate and commit to the final value" )
        //current target win value current process or win flow will eventually come up to:
        .withLatestFrom( $winTarget, ( up, value ) => ({ up, value }) )
        .subscribe( ({ up, value }) =>
        {
            interrupt( value );
            $winTarget.next( value + up );
            
            const win = { value };
            const to = value + up;
            const time = 1000 * Math.log( to - value );
            tween = space.tween( win )
                .to( { value : to }, time )
                .onUpdate( () => $winFlow.next( win.value | 0 ) )
                .onComplete( winFlowDone )
                .onStop( winFlowDone )
                .start();
        } );
    
    //recover previous winnings within current scenario and allow animations to flow it up:
    $state
        .take( 1 )
        .subscribe( state =>
        {
            const winTarget = state.server.totalWinInCoins - state.server.spinWinInCoins;
            $winTarget.next( winTarget );
            $winFlow.next( winTarget );
        } );
    //replicate server-side win on specific states to both restore state on those states and mute any flow errors which may happen on previous state:
    $state
        .filter( state => _.includes(
            [
                network.TYPE.RISK_MAIN,
                network.TYPE.RISK_RESULT,
                network.TYPE.FINISH,
                network.TYPE.FINAL,
            ],
            state.type
        ) )
        .name( space, "replicate" )
        .subscribe( state =>
        {
            $winTarget.next( state.server.totalWinInCoins );
            interrupt( state.server.totalWinInCoins );
        } );
    
    return space;
}





// WEBPACK FOOTER //
// ./src/library/balance.es6